import run from "../../animate/run";

/**
 *
 * @param {MainClassProps} main
 * @param {Map<String, String>} local
 * @param {String} name
 * @returns
 */
const initLocalClasses = (main, local, name) => {
  if (!local) {
    return;
  }

  for (const [key, value] of local) {
    if (value !== name) {
      continue;
    }

    if (main.element.classList.contains(key)) {
      main.isVisible = true;
      run(main.events.get(`classadded:${name}`), "enter");
    }
  }
};

export default initLocalClasses;
